import { render, staticRenderFns } from "./TableOperateButton.vue?vue&type=template&id=56e7103a"
import script from "./TableOperateButton.vue?vue&type=script&lang=js"
export * from "./TableOperateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports